import type { Styles } from '@adornis/ass/style.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { DlaFooterPage } from './dla-footer-page.js';

/**
 * @element dla-accessibility
 */
@customElement('dla-accessibility')
export class DlaAccessibility extends DlaFooterPage {
  override render() {
    return html`
      <x-flex class="container" space="xl">
        ${this.backButton()}

        <x-flex space="md">
          <x-h1> Erklärung zur Barrierefreiheit </x-h1>
          <x-h2> Barrierefreiheit </x-h2>
        </x-flex>
        <x-text>
          studiumdigitale als Websitebetreiber ist bemüht, die Website in Einklang mit den einschlägigen Vorschriften
          zur Barrierefreiheit zu gestalten. Für uns gelten folgende Rechtsvorschriften:
        </x-text>
        <x-text>
          Hessisches Gesetz zur Gleichstellung von Menschen mit Behinderungen (Hessisches
          Behinderten-Gleichstellungsgesetz – HessBGG) und Hessische Verordnung über barrierefreie Informationstechnik
          (BITV HE 2019)
        </x-text>

        <x-h2> Website </x-h2>
        <x-text>
          Diese Erklärung zur Barrierefreiheit gilt für die Website
          https://netzwerktag.studiumdigitale.uni-frankfurt.de.
        </x-text>
        <x-text> Diese Website wurde am 01.10.2024 veröffentlicht. </x-text>

        <x-h2> Feedback und Kontaktangaben </x-h2>
        <x-text>
          Sind Ihnen Mängel beim barrierefreien Zugang zu Inhalten auf unserer Website aufgefallen oder haben Sie
          Anmerkungen sowie Fragen zum barrierefreien Zugang? Melden Sie sich gerne bei uns unter:
        </x-text>

        <x-flex space="md">
          <x-text> Johann Wolfgang Goethe-Universität </x-text>
          <x-text> studiumdigitale </x-text>
        </x-flex>

        <x-flex space="md">
          <x-text> Telefon: +49 (0) 69 / 798-22198 </x-text>
          <x-text> Telefax: +49 (0) 69 / 798-22195 </x-text>
          <x-text> Email: info@studiumdigitale.uni-frankfurt.de </x-text>
          <x-text> Internet: www.studiumdigitale.uni-frankfurt.de </x-text>
        </x-flex>
      </x-flex>
    `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          overflowY: 'auto',
        },
        '.container': {
          width: '100%',
          maxWidth: this.sizes.maxReadableWidth,
          margin: '0 auto',
          paddingTop: this.spacing.lg,
          paddingBottom: this.spacing.xl,
        },
      } as Styles,
    ];
  }
}
